import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { appAxios } from "../../axios/axios";
import CreateNewAgent from "../FlightEnquiryForm/CreateNewAgent";
import FormModal from "../FlightEnquiryForm/FormModal";
import { IOtherEnquiry } from "../types/flights";
import { getAuthToken } from "../../commonGlobals/functions/localStorage/getUser";
import { LoadingButton } from "../Common/Ui/LoadingButton";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomInput } from "../Common/Ui/CustomInput";
const CustomCkEditor = React.lazy(() => import("../Common/Ui/CustomCkEditor"));

const OtherEnquiry: React.FC<{
  onSaveEnquiry?: any;
  onBehalfByStaff?: boolean;
  userData?: any;
}> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const otherEnquiryData: IOtherEnquiry = location?.state?.enquiryData;
  const enquiryId: number = location?.state?.enquiryId;
  const isUpdating = otherEnquiryData ? true : false;
  const [otherQuery, updateOtherQuery] = useState<IOtherEnquiry>({
    remark: "",
    passengers: [],
    type: "Other Enquiry",
  });
  const [show, setShow] = useState(false);
  const [handleModalClose, setHandleModalClose] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const userModalHandleClose = () => setHandleModalClose(false);
  const handleShow = () => setShow(true);

  // const [captchaToken, setCaptchaToken] = useState<string | undefined>(
  //   undefined
  // );
  // const reCaptchaRef = useRef<any>();
  const isLoogedIn = getAuthToken();

  const saveEnquiry = async () => {
    if (!otherQuery.remark || otherQuery.remark.trim().length === 0) {
      return toast.error("Please enter remark");
    }

    if (!isLoogedIn) {
      setHandleModalClose(true);
      return;
    }

    // let token;
    // if (!captchaToken) {
    //   token = await reCaptchaRef.current.executeAsync();
    //   setCaptchaToken(token);
    // }
    // if (!captchaToken && !token) {
    //   return toast.error("Please solve captcha");
    // }
    setRequestLoading(true);
    try {
      const url = "/query/saveOtherEnquiry";
      const dataToBeSend = props.onBehalfByStaff
        ? {
            enquiryData: otherQuery,
            userData: props.userData && props.userData,
            isOnBehalf: props.onBehalfByStaff,
          }
        : {
            enquiryData: otherQuery,
          };
      const saveResponse = await appAxios(url, {
        method: "POST",
        data: dataToBeSend,

        // headers: {
        //   "captcha-token": captchaToken ? captchaToken : token,
        // },
      });

      if (saveResponse.data.success) {
        props.onSaveEnquiry && props.onSaveEnquiry();
        toast.success("Enquiry saved successfully");
      }
    } catch (error: any) {
      const errorMessage = "Unable to save enquiry!!";
      toast.error(errorMessage);
    } finally {
      setRequestLoading(false);
    }
    // reCaptchaRef.current.reset();
    // setCaptchaToken(undefined);
  };

  const updateEnquiry = async () => {
    if (!otherQuery.title || otherQuery.title.trim().length === 0) {
      return toast.error("Please enter title");
    }
    if (!otherQuery.remark || otherQuery.remark.trim().length === 0) {
      return toast.error("Please enter remark");
    }
    // let token;
    // if (!captchaToken) {
    //   token = await reCaptchaRef.current.executeAsync();
    //   setCaptchaToken(token);
    // }
    // if (!captchaToken && !token) {
    //   return toast.error("Please solve captcha");
    // }
    setRequestLoading(true);
    try {
      const updateResponse = await appAxios("/query/updateEnquiry", {
        method: "POST",
        // headers: {
        //   "captcha-token": captchaToken ? captchaToken : token,
        // },
        data: {
          enquiryData: {
            id: enquiryId,
            ...otherQuery,
          },
        },
      });
      if (updateResponse.data.success) {
        toast.success("Enquiry updated successfully");
        navigate(`/enquiry/${enquiryId}`, {
          replace: true,
        });
      }
    } catch (error) {
      const errorMessage = "Unable to update enquiry!!";
      toast.error(errorMessage);
    }
    setRequestLoading(false);
    // reCaptchaRef.current.reset();
    // setCaptchaToken(undefined);
  };

  useEffect(() => {
    if (otherEnquiryData) {
      updateOtherQuery(otherEnquiryData);
    }
  }, [otherEnquiryData]);

  return (
    <React.Fragment>
      <div className="tab-pane active p-4 pb-4">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="module-name">
              <h3 className="after-heading">Other Enquiry</h3>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <label className="small">Title</label>
            <CustomInput
              className="small"
              value={otherQuery.title}
              onChange={(e) => {
                updateOtherQuery((old) => {
                  old.title = e.target.value;
                  return { ...old };
                });
              }}
              maxLength={50}
            />
            <p>Characters remaining: {50 - (otherQuery.title?.length || 0)}</p>
            <label className="small">Editer</label>
            <CustomCkEditor
              data={otherQuery.remark}
              onChange={(data) => {
                updateOtherQuery((old: IOtherEnquiry) => {
                  old.remark = data;
                  return { ...old };
                });
              }}
              placeholder="Enter enquiry details..."
            />

            <button
              className="btn btn-outline-light small mt-3"
              onClick={handleShow}
              type="button"
            >
              Add Passengers
            </button>
          </div>

          {/* <div className="mt-4 col-lg-4 col-md-6 col-sm-12 col-12">
            {!isLoogedIn && (
              <ReCaptcha
                setToken={(token: string) => {
                  setCaptchaToken(token);
                }}
                myRef={reCaptchaRef}
              />
            )}
          </div> */}
        </div>
        <div>
          <LoadingButton
            loading={requestLoading}
            onClick={isUpdating ? updateEnquiry : saveEnquiry}
          >
            {isUpdating ? "Update " : "Save "}Enquiry
          </LoadingButton>
        </div>

        {show && (
          <FormModal
            show={show}
            handleClose={() => setShow(false)}
            passengers={[...otherQuery.passengers]}
            saveHandler={(passengers) => {
              updateOtherQuery((old) => {
                old.passengers = passengers;
                return { ...old };
              });
              setShow(false);
              toast.success("Passenger details saved successfully");
            }}
          />
        )}

        <CreateNewAgent
          handleModalClose={userModalHandleClose}
          changeQueryData={() => {
            updateOtherQuery({
              remark: "<p>Enter The Text </p>",
              passengers: [],
              type: "Other Enquiry",
            });
          }}
          url="/query/saveOtherEnquiry"
          isModalOpen={handleModalClose}
          queryData={otherQuery}
        />
      </div>
    </React.Fragment>
  );
};

export default OtherEnquiry;
